module.exports = __webpack_public_path__ + "img/os.98239051.png";